import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f113619"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-administrator-resources-root-diets-list" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = { class: "box__headline" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, " Prehrana ", -1))
const _hoisted_5 = { class: "action" }
const _hoisted_6 = {
  key: 0,
  class: "box__list"
}
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "name" }
const _hoisted_9 = { class: "action" }
const _hoisted_10 = {
  key: 1,
  class: "box__message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoFilled = _resolveComponent("InfoFilled")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppAdministratorResourcesRootDietsFormLookupVue = _resolveComponent("AppAdministratorResourcesRootDietsFormLookupVue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, {
            class: "el-button el-button--primary el-button--grey el-button--square",
            to: { name: 'AppAdministratorResourcesDietsIndexVue' }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_InfoFilled)
            ]),
            _: 1
          })
        ])
      ]),
      (_ctx.diets.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.diets, (diet) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: diet.id
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(diet.content.name), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_AppAdministratorResourcesRootDietsFormLookupVue, { diet: diet }, null, 8, ["diet"])
                ])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, " Nema podataka... "))
    ])
  ]))
}